var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSong = function SvgSong(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.58 23.914a6.25 6.25 0 1 1 8.84 8.839 6.25 6.25 0 0 1-8.84-8.839m4.42.67a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.75 6.667c0-.69.56-1.25 1.25-1.25h16.667c.69 0 1.25.56 1.25 1.25V20a1.25 1.25 0 0 1-2.5 0V7.917H16.25v20.416a1.25 1.25 0 1 1-2.5 0z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.75 13.333c0-.69.56-1.25 1.25-1.25h16.667a1.25 1.25 0 0 1 0 2.5H15c-.69 0-1.25-.56-1.25-1.25M32.36 25.627a1.25 1.25 0 0 1 .347 1.733l-2.038 3.057H35a1.25 1.25 0 0 1 1.04 1.943l-3.333 5a1.25 1.25 0 1 1-2.08-1.387l2.037-3.056h-4.33a1.25 1.25 0 0 1-1.04-1.944l3.333-5a1.25 1.25 0 0 1 1.733-.346",
    clipRule: "evenodd"
  })));
};
export default SvgSong;